import { InjectionToken } from '@angular/core';

export const CONTAINER_MODE = new InjectionToken<string>(
  'app.context.containerMode',
);

export enum ContainerModes {
  View = 'view',
  Edit = 'edit',
  ViewAsStudent = 'view_as_student',
}

export function getValidatedContainerMode(
  maybeValue: string | null,
): ContainerModes {
  switch (maybeValue) {
    case ContainerModes.Edit:
      return ContainerModes.Edit;
    case ContainerModes.View:
      return ContainerModes.View;
    case ContainerModes.ViewAsStudent:
      return ContainerModes.ViewAsStudent;
    default:
      return ContainerModes.View;
  }
}
